// react
import React, { useEffect, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import ChartistGraph from "react-chartist";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import InputBase from '@material-ui/core/InputBase';
import Button from "beaktShared/components/CustomButtons/Button.js";
import { useReactToPrint } from 'react-to-print';

// services
import { SessionContext } from "beaktShared/services/session";
import { setAvaliacaoCookie, getAvaliacaoCookie, getAvaliacaoConsultaCookie, setAvaliacaoConsultaCookie } from 'beaktClinic/services/avaliacaoCookie';
import { UsePostApi, UseDeleteApi } from "beaktShared/services/crudeApiService";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

// images
import logoDrDiabetes from 'assets/img/logoDrDiabetes.png';
import homemAvaliacaoDrDiabetes from "assets/img/avaliacao/homemAvaliacaoDrDiabetes.png";
import graficoDrDiabetes from "assets/img/avaliacao/graficoDrDiabetes.png";


// styles
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from "assets/jss/BeaktClinic/views/Venda/contratoVenda.js";
const useStyles = makeStyles(styles);

export default function ResultadoDrDiabetes({previousButtonClick, classes_wizard}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const { register, setValue, errors} = useForm({mode: "onBlur"}); 
  
  const [avaliacaoId, setAvaliacaoId] = React.useState(0);
  const [notification, setNotification] = React.useState(false);
  const [colorNotification, setColorNotification] = React.useState('info');    
  const [mensagemNotification, setMensagemNotification] = React.useState(false);
  const showNotification = (mensagem,color) => { 
      setMensagemNotification(mensagem);
      setColorNotification(color);      
      setNotification(true);
      setTimeout(function() {
          setNotification(false);
      }, 6000);       
  };

  const [imagemHomem, setimagemHomem] = React.useState();
  const [grafico, setGrafico] = React.useState();


  const [imagem, setImagem] = React.useState({
    imagem1 : '',
    imagem2 : '',
    imagem3 : '',
    imagem4 : '',
    imagem5 : '',
    imagem6 : '',
    imagem7 : '',
    imagem8 : '',
    imagem9 : '',
  })

  const reinicializarClick = () => {
    setAvaliacaoCookie(null);
    setAvaliacaoConsultaCookie(null);
    window.location.href = '/adminclinic/avaliacao'
  }
  
  const handleDelete = () => {
    var userDeletadoId = session.id;    

    const endPoint = 'avaliacoes/';    
    UseDeleteApi(endPoint, avaliacaoId, userDeletadoId).then(result => {
        showNotification(result.message, 'success');
        reinicializarClick();
        return true;
    });
  };

  //Função Imprimir
  const refImprimir = useRef();
  const handlePrint = useReactToPrint({
      content: () => refImprimir.current,
      copyStyles: true,
      documentTitle: "",
  });

  const [loadingImagem, setloadingImagem] = React.useState(false);
  const[dadosCliente, setDadosCliente] = React.useState({
    descricao : ''
  })
  
  const [percentualGorduraNormal, setpercentualGorduraNormal] = React.useState({desc: "", value: ""});
  const [resultText, setresultText] = React.useState("");
  const setResultadoAvaliacao = (result) => {
      
      let avaliacao = getAvaliacaoCookie();      

      if (getAvaliacaoConsultaCookie() != null)
      {
        avaliacao = getAvaliacaoConsultaCookie();        
        setAvaliacaoConsultaCookie(null);
      }
      else{
        setAvaliacaoCookie(null);  
      }

      if (avaliacao.cliente.sexo == 1){
        setpercentualGorduraNormal({desc: t('avaliation.percent_fat_ok_man'), value: "10 a 19 %"});
        setValue("percentualGorduraNormal","10 a 19 %");
      }else{
        setpercentualGorduraNormal({desc: t('avaliation.percent_fat_ok_woman'), value: "20 a 29 %"});
        setValue("percentualGorduraNormal","20 a 29 %");
      }
      setAvaliacaoId(result.data.avaliacaoId);
      
      setDadosCliente({ sexo: avaliacao.cliente.sexo, nome : avaliacao.cliente.nome,  descricao : ' Idade: ' + avaliacao.idade + ' | Peso: '  + avaliacao.kg + ' | Altura: '  + avaliacao.altura + ' | Cintura: ' + avaliacao.cintura + ' | Quadril: ' + avaliacao.quadril + ' | Telefone: ' + avaliacao.cliente.celular + ' | Email: ' + avaliacao.cliente.email });

      setValue("gorduraCorporal",result.data.gorduraCorporal + " %");
      setValue("corporalEquivalente",result.data.corporalEquivalente + " Kg");
      setValue("gorduraLocalizada",result.data.gorduraLocalizada + " %");
      setValue("localizadaEquivalente",result.data.localizadaEquivalente + " Kg");
      setValue("get",result.data.get);
      setValue("rcq",result.data.rcq);
      setValue("rcq2",result.data.rcq);
      setValue("massaOssea",result.data.massaOssea + " Kg");

     
      if(result.data.rcq_texto==="VOCE TEM RISCO AUMENTADO P/ DIABETES, HIPERTENSÃO E DOENÇAS CORONÁRIAS")
        setresultText(result.data.rcq + '-' + t('avaliation.high_risk'))
      else if(result.data.rcq_texto==="VOCE TEM RISCO DIMINUIDO P/ DIABETES, HIPERTENSÃO E DOENÇAS CORONÁRIAS")
        setresultText(result.data.rcq + '-' + t('avaliation.low_risk'))
        
      setValue("imc",result.data.massaCorporal);
      setValue("peso",result.data.peso + " Kg");

      setValue("pesoNormal",result.data.pesoNormal + " Kg");
      setValue("pesoIdeal",result.data.pesoIdeal + " Kg");

      setValue("perderPesoIdeal",result.data.perderPesoIdeal + " Kg");
      setValue("perderPesoNormal",result.data.perderPesoNormal + " Kg");

      setValue("obesidade",result.data.obesidade + " Kg");
      setValue("perderObesidade",result.data.perderObesidade + " Kg");

      setValue("magro","(   )");
      setValue("obesidade_peso","(   )");
      setValue("dentro_peso","(   )");
      setValue("acima_peso","(   )");

      if(result.data.bioTipo === 'Magro')
        setValue("magro","( X )");

      if(result.data.bioTipo === 'Dentro do Peso')
        setValue("dentro_peso","( X )");

      if(result.data.bioTipo === 'Acima do Peso')
        setValue("acima_peso","( X )");

      if(result.data.bioTipo === 'Obeso')
        setValue("obesidade_peso","( X )");


      setloadingImagem(false);      
      
      set_colouredLineChart({
        labels: [
          t('avaliation.age_5_years_before') +":" + (parseInt(avaliacao.idade) - 5),
          t('avaliation.age') +":"  + parseInt(avaliacao.idade),
          t('avaliation.age_5_years_after') +":"  + (parseInt(avaliacao.idade) + 5),
        ],
        series: [[parseInt(avaliacao.peso5anos),parseInt(result.data.peso),parseInt(result.data.pesoIdeal)]]
      });
  }

  useEffect(() => {

    setloadingImagem(true);

    let avaliacao = getAvaliacaoCookie();    
    
    if (getAvaliacaoConsultaCookie() != null)
      avaliacao = getAvaliacaoConsultaCookie();

    let dadosPost = {
      avaliacaoId : (avaliacao.avaliacaoId != null ? avaliacao.avaliacaoId : 0),
      usuarioCadastroId :  session.id ,         
      estabelecimentoId : session.estabelecimentoId,
      clienteId : 0 ,
      cliente : avaliacao.cliente,
      canalMidiaId : avaliacao.canalMidia,  
      idade : avaliacao.idade, 
      peso :  avaliacao.kg, 
      altura : avaliacao.altura, 
      quadril : avaliacao.quadril, 
      cintura : avaliacao.cintura, 
      peso5Anos : avaliacao.peso5anos, 
      percentualGordura :  avaliacao.gordura, 
      nivel :  avaliacao.sedentarismo, 
      fatorNivel : 0, 
      deletado : false,
      gorduraCorporal : 0, 
      corporalEquivalente : 0, 
      massaCorporal : 0, 
      gorduraLocalizada : 0, 
      pesoIdeal : 0, 
      diametroPunho: avaliacao.diametroPunho,
      diametroJoelho: avaliacao.diametroJoelho,
      massaOssea: avaliacao.massaOssea,
      realizaAcompanhamentoDiabete: avaliacao.realizaAcompanhamentoDiabete,
    }
    
    console.log(dadosPost);

    let endPoint = "avaliacoes/";

    if (avaliacao != null && avaliacao.avaliacaoId != null && avaliacao.avaliacaoId != 0){
      endPoint = endPoint + "CalculaAvaliacao"
    }

    UsePostApi(endPoint,dadosPost).then(result=>{       
      if(result.status === 200 || result.status === 201)
      {                
        setResultadoAvaliacao(result);
      }  
      else{
        showNotification(result.message,'danger');
        setloadingImagem(false);
      }
    });
    
  }, []);

  var delays = 80, durations = 500;
  var Chartist = require("chartist");
  const [_colouredLineChart, set_colouredLineChart] = React.useState({
    labels: [
      "'06",
      "'07",
      "'08",
      "'09",
      "'10",
      "'11",
      "'12",
      "'13",
      "'14",
      "'15"
    ],
    series: [[287, 480, 290, 554, 690, 690, 500, 752, 650, 900, 944]]
  });

  const colouredLineChart = {
    data: _colouredLineChart,
    options: {
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 30
      }),
      axisY: {
        showGrid: true,
        offset: 30
      },
      axisX: {
        showGrid: false
      },
      low: 0,
      high: 150,
      showPoint: true,
      height: "250px"
    },
    animation: {
      draw: function(data) {
        if (data.type === "line" || data.type === "area") {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path
                .clone()
                .scale(1, 0)
                .translate(0, data.chartRect.height())
                .stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === "point") {
          data.element.animate({
            opacity: {
              begin: (data.index + 1) * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: "ease"
            }
          });
        }
      }
    }
  };

return (

    <div>   
        <Snackbar
          place="tr"
          color={colorNotification}
          message={mensagemNotification}
          open={notification}
          closeNotification={() => setNotification(false)}
          close          
        />

        {loadingImagem &&
          <div className="carregandoCmp">
              <div className="box">
                <label>{t('label.loading')}...</label>
                <CircularProgress />
              </div>
          </div> 
        }  
      
        <div id="div_Resultado"  ref={refImprimir} className="allowPrintFixed" style={{margin:'0px auto!important', padding:'0px !important', width:'98%'}}>
            
              <div style={{borderTop:'solid 1px black',borderBottom:'solid 1px black'}}>
                <GridContainer className={classes.boxAvaliacao} alignItems={'center'} style={{margin:'10px 0'}}>
                  <GridItem  xs={6} md={6} style={{paddingLeft:'30px',borderRight:'solid 1px black'}}>
                    <div style={{textAlign:'center'}}>
                      <img src={logoDrDiabetes} style={{maxWidth:'380px'}}/>
                    </div>
                  </GridItem>
                  <GridItem  xs={3} md={3} style={{textAlign:'center'}}>
                      UNIDADE: <strong>{session.estabelecimentoDescricao}</strong>
                  </GridItem>
                </GridContainer>
              </div> 
              <div>
                <GridContainer className={classes.boxAvaliacao} alignItems={'center'} style={{margin:'10px 0'}}>
                 
                  <GridItem  xs={4} md={4} style={{paddingLeft:'30px'}}>
                    <div style={{textAlign:'center'}}>
                        <h3 className={classes.titleStep}>{t('avaliation.body_avaliation')}: </h3>
                    </div>
                  </GridItem>
                  <GridItem  xs={8} md={8} style={{textAlign:'center',padding:'0 10px'}}>
                    <p> <strong>{dadosCliente.nome}</strong> - {dadosCliente.descricao}</p>
                  </GridItem>
                </GridContainer>
              </div> 
              <GridContainer className={classes.boxAvaliacao} alignItems={'center'} style={{margin:'10px 0'}}> 
              
              <GridContainer className="BoxPrint">
              <hr className="linha"/>
                  <GridItem xs={12} md={12}>
                      <div className={classes.titleStep2 + "BoxStep"} style={{padding:"0px !important"}}>
                        <h4 className={classes.titleStep}>1. Indicador de Síndromes Metabólicas</h4>
                      </div>
                  </GridItem>
                  
                  <GridItem xs={6} md={6} className="BoxAvaliacao" >
                  <table className="tabelaItem6"  id="tabelaIMC" > 
                    <tbody>
                      <tr>
                        <td>{t('avaliation.fat_body')} </td>
                        <td>
                        <InputBase
                              readOnly={true}
                              name="gorduraCorporal"
                              inputRef={register({ required: true })}
                              inputProps={{ 'aria-label': 'naked' }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{fontWeight:'bold'}}>{t('avaliation.equivalent_to')}</td>
                        <td>
                        <InputBase
                              readOnly={true}
                              name="corporalEquivalente"  
                              inputRef={register({ required: true })}
                              inputProps={{ 'aria-label': 'naked' }}
                              style={{fontWeight:'bold'}}
                          />
                        </td>
                      </tr> 
                      <tr>
                        <td>{percentualGorduraNormal.desc}</td>
                        <td>
                        <InputBase
                              readOnly={true}
                              name="percentualGorduraNormal"  
                              inputRef={register({ required: true })}
                              inputProps={{ 'aria-label': 'naked' }}
                              className={classes.margin}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>{t('avaliation.localized_fat')}</td>
                        <td>
                        <InputBase
                              readOnly={true}
                              name="gorduraLocalizada"  
                              inputRef={register({ required: true })}
                              inputProps={{ 'aria-label': 'naked' }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>{t('avaliation.equivalent_to')}</td>
                        <td>
                        <InputBase
                              readOnly={true}
                              name="localizadaEquivalente"  
                              inputRef={register({ required: true })}
                              inputProps={{ 'aria-label': 'naked' }}
                              className={classes.margin}
                          />
                        </td>
                      </tr>     
                      <tr>
                        <td>Massa Óssea</td>
                        <td>
                        <InputBase
                              readOnly={true}
                              name="massaOssea"  
                              inputRef={register({ required: true })}
                              inputProps={{ 'aria-label': 'naked' }}
                              className={classes.margin}
                          />
                        </td>
                      </tr>                   
                    </tbody>
                  </table>

                  
                  </GridItem>
                 
               </GridContainer>
          <GridContainer className="BoxPrint">
            <hr className="linha"/>
                  <GridItem xs={12} md={12}>
                      <div className={classes.titleStep2 + "BoxStep"} style={{padding:"0px !important"}}>
                        <h4 className={classes.titleStep}>2. {t('avaliation.daily_get')}</h4>
                      </div>
                  </GridItem>
                  <GridItem className="BoxAvaliacao" md={6} xs={6}>
                    <ChartistGraph
                          className="LineGrafico"
                          data={colouredLineChart.data}
                          type="Line"
                          options={colouredLineChart.options}
                          listener={colouredLineChart.animation}
                        />
                  </GridItem>
                  <GridItem  className="BoxAvaliacao" xs={6} md={6}>
                  <table className="tabelaItem6"  id="tabelaIMC" style={{fontSize: '1.3em'}}> 
                    <tbody>
                      <tr>
                        <td>{t('avaliation.current_weight')}:</td>
                        <td>
                          <InputBase
                            readOnly={true}
                            name="peso"
                            inputRef={register({ required: false })}
                            inputProps={{ 'aria-label': 'naked' }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>{t('avaliation.your_get_is')}:</td>
                        <td>
                          <InputBase
                            readOnly={true}
                            name="get"  
                            inputRef={register({ required: false })}
                            inputProps={{ 'aria-label': 'naked' }}
                            className={classes.margin}
                          />
                        </td>
                      </tr> 
                      <tr>
                        <td>{t('avaliation.your_rcq_is')}:</td>
                        <td>
                          <InputBase
                            readOnly={true}
                            name="rcq"  
                            inputRef={register({ required: false })}
                            inputProps={{ 'aria-label': 'naked' }}
                            className={classes.margin}
                          />
                        </td>
                      </tr>             
                    </tbody>
                  </table>
                  <p>A obesidade é definida como um aumento excessivo da quantidade de gordura, resultante de um desequilibrio entre as calorias consumidas e as
                      calorias gastas para suprir as atividades diárias. <br/>
                      O peso corporal permanece constante enquanto as calorias ingeridas forem equivalentes às calorias gastas para suprir as atividades diárias.<br/>
                      Quando as calorias ingeridas excedem as necessidades este excesso é armazenado em forma de gordura.</p>
              </GridItem>
              
                  
          </GridContainer>
              
          <GridContainer className="BoxPrint">
            <hr className="linha"/>
              <GridItem sm={12} md={12} >
                  <div className={classes.titleStep2 + "BoxStep"} style={{padding:"0px !important"}}>
                    <h4 className={classes.titleStep}>3. {t('avaliation.metabolic_risk')}</h4>
                  </div>
                  <div style={{textAlign:'center'}} className="metabolicRisc"> 
                    {t('avaliation.your_metabolic_risk_is')}: <span style={{fontWeight:'bold'}}>{resultText}</span>
                    </div>
               
              </GridItem>
              <GridItem sm={12} md={12}>
                <div style={{margin:"10px 0",textAlign:'justify'}}>
                    <p style={{marginTop:'-10px'}}> 
                      {t('avaliation.metabolic_text')} 
                    </p>
                  </div>
              </GridItem>
              <GridItem sm={12} md={12} style={{marginLeft:'12px'}}>
              <center>
                <div style={{width: '700px'}}>
                
                  <img src={homemAvaliacaoDrDiabetes} />
              
                </div>
                </center>
              </GridItem>
              <GridItem sm={12} md={12} style={{marginTop: '20px'}}>
                <div>
                 <img  src={graficoDrDiabetes}/>
                </div>
              </GridItem>
              </GridContainer>
            </GridContainer>

        </div>             
      <div className="no-print">
          <div style={{textAlign:'center'}}>
              <div>                  
                <Button color="warning" onClick={() => reinicializarClick()} > {t('button.restart')} </Button>

                <Button color="danger" onClick={() => handleDelete()}> {t('button.delete')} </Button>

                <Button color="info" onClick={handlePrint}> {t('button.print')} </Button>

              </div>
          </div>          
      </div>
    
    </div>
 
);
}